<template>
  <iq-card>
    <template v-if="update" v-slot:headerTitle>
      <slot name="headerTitle">
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fas fa-hospital"></i>
          {{ $t("public.components.organization.box.title") }}
        </h4>
      </slot>
    </template>
    <template v-if="update" v-slot:headerAction>
      <slot name="headerActionMoreBtn"></slot>
      <b-button v-if="
        checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', ['CREATE'])
      " style="right" variant="success" @click="openModal('CREATE')">{{
  $t("public.components.organization.box.btnCreate")
}}
      </b-button>
    </template>
    <template v-if="checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', ['LIST'])" v-slot:body>
      <div class="text-right">
        <b-button class="mb-3 mr-1" variant="secondary" @click="getBoxesExcel">
          Excel
        </b-button>
      </div>
      <div>
        <v-card-title>
          <v-text-field v-model="searchBox" append-icon="mdi-magnify" hide-details single-line @blur="
            $parent.getAllBoxes(
              organizationId,
              paginationBox.page - 1,
              paginationBox.itemsPerPage,
              { name: searchBox }
            )
          ">
            <template slot="label">
              <div class="search-datatable">
                <i class="fas fa-search fa-fw"></i>
                {{ $t("public.components.organization.box.search") }}
              </div>
            </template>
          </v-text-field>
        </v-card-title>
        <v-data-table :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-arrow-left',
          lastIcon: 'fas fa-arrow-right',
          prevIcon: 'fas fa-minus',
          nextIcon: 'fas fa-plus',
          'items-per-page-options': [10, 25, 50],
        }" :headers="headersBoxes" :items="boxes" :options.sync="paginationBox" :server-items-length="total"
          item-key="id">
          <template v-slot:item.actions="{ item }">
            <div class="div-table-data">
              <button v-if="
                checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                  'EDIT',
                ])
              " :id="'btnUpdateBox' + item.id" class="item" v-on:click="openModal('UPDATE', item.id)">
                <i class="ri-refresh-line"></i>
              </button>
              <b-popover v-if="
                checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                  'EDIT',
                ])
              " :target="'btnUpdateBox' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t("public.components.organization.box.btnUpdate")
                }}
                </template>
              </b-popover>
              <button v-if="
                checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                  'DELETE',
                ])
              " :id="'btnRemoveBox' + item.id" class="item" v-on:click="remove(item.id)">
                <i class="ri-delete-bin-line"></i>
              </button>
              <b-popover v-if="
                checkPermissionProfessional('ORGANIZATION_VISIT_TYPES', [
                  'DELETE',
                ])
              " :target="'btnRemoveBox' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t("public.components.organization.box.btnRemove")
                }}
                </template>
              </b-popover>
            </div>
          </template>
        </v-data-table>

        <b-modal id="modal-new" :hide-footer="action === 'VIEW'" centered @ok="saveFormStep1">
          <template #modal-title><span v-if="action === 'CREATE'">
              {{
                $t(
                            "public.components.organization.box.modalCreate.title.create"
                )
              }}
            </span>
            <span v-if="action === 'UPDATE'">
              {{
                $t(
                            "public.components.organization.box.modalCreate.title.update"
                )
              }}
            </span>
          </template>
          <template v-if="action === 'CREATE' || action === 'UPDATE'" #modal-ok>
            <div v-if="action === 'CREATE'">
              {{
                $t("public.components.organization.box.modalCreate.btnCreate")
              }}
            </div>
            <div v-if="action === 'UPDATE'">
              {{
                $t("public.components.organization.box.modalCreate.btnUpdate")
              }}
            </div>
          </template>
          <template #modal-cancel>{{
            $t("public.components.organization.box.modalCreate.btnCancel")
          }}
          </template>
          <form action="#">
            <b-form-group label-for="name">
              <template slot="label">{{
                $t("public.components.organization.box.modalCreate.name")
              }}: *
              </template>
              <b-form-input id="nombre" v-model="name" type="text" v-bind:class="{
                'text-danger': isFormNameErrors,
                'is-invalid': isFormNameErrors,
              }" @blur="checkName(name)"></b-form-input>
              <ul v-if="isFormNameErrors">
                <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index"
                  class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>
          </form>
        </b-modal>
      </div>
    </template>
    <notifications group="notificacions" />
  </iq-card>
</template>
<script>
import { xray } from "../../config/pluginInit";

import validator from "vue-m-validator";

import organizationService from "../../services/organization";
import utilsService from "../../services/utils";

export default {
  name: "VisitType",
  props: {
    start: false,
    organizationId: "",
    total: 0,
    boxes: [],
    update: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    xray.index();
  },
  computed: {
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
  },
  watch: {
    paginationBox: {
      handler() {
        if (this.start) {
          this.$parent.getAllBoxes(this.organizationId, 0, 1000, {
            name: this.searchBox,
          });
        }
        this.start = true;
      },
    },
  },
  methods: {
    getBoxesExcel() {
      let data = { name: this.searchBox };

      this.$awn.asyncBlock(
        organizationService.getAllBoxesExcel(this.organizationId, data),
        (response) => {
          if (response) {
            saveAs(response.data, "boxes.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllBoxesExcel",
            module: "component-organization-box",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ organizationId: this.organizationId, data: data }),
          });
        },
        " "
      );
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    notFirst() {
      this.isFirstRun = false;
    },

    checkName(_name) {
      const NAME = _name;
      const RULE_1 = {
        expression: NAME === undefined || NAME === null || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.components.organization.box.errors.erName"),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    saveFormStep1(evt) {
      evt.preventDefault();

      if (this.action === "CREATE") {
        this.checkFormStep1();
        if (this.validatorStep1.errors.length === 0) {
          this.create(this.organizationId);
        } else {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.box.errors.erTitle"
            ),
            text: this.$i18n.t(
              "public.components.organization.box.errors.erStep1"
            ),
            type: "error",
          });
        }
      }
      if (this.action === "UPDATE") {
        this.checkFormStep1();
        if (this.validatorStep1.errors.length === 0) {
          this.updateBox();
        } else {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.organization.box.errors.erTitle"
            ),
            text: this.$i18n.t(
              "public.components.organization.box.errors.erStep1"
            ),
            type: "error",
          });
        }
      }
    },
    openModal(action, boxId) {
      this.action = action;
      if (action === "CREATE") {
        this.disabled = false;
        this.clearForm();
        this.$bvModal.show("modal-new");
      }
      if (action === "UPDATE") {
        this.disabled = false;
        this.get(boxId);
        this.$bvModal.show("modal-new");
      }
    },
    clearForm() {
      this.validatorStep1.errors = [];
      this.name = "";
    },
    checkFormStep1() {
      this.checkName(this.name);
    },
    create(organizationId) {
      let self = this;

      var data = {
        name: this.name,
      };

      this.$awn.asyncBlock(
        organizationService.saveBox(organizationId, data),
        (response) => {
          if (response) {
            //Close modal
            self.$bvModal.hide("modal-new");
            self.$parent.getAllBoxes(
              self.organizationId,
              self.paginationBox.page - 1,
              self.paginationBox.itemsPerPage,
              { name: this.searchBox }
            );
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.box.modalCreate.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.box.modalCreate.notification.desc"
              ),
              type: "success",
            });

            //:TODO tiene que actualizar el datatable
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "self.$parent.getAllBoxes",
            module: "component-organization-box",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: self.organizationId,
              page: self.paginationBox.page - 1,
              itemsPerPage: self.paginationBox.itemsPerPage,
              data: { name: this.searchBox }
            }),
          });
        },
        " "
      );
    },
    //Update
    get(boxId) {
      let self = this;
      this.$awn.asyncBlock(
        organizationService.findBox(boxId, this.organizationId),
        (response) => {
          if (response) {
            self.id = response.data.id;
            self.name = response.data.name;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findBox",
            module: "component-organization-box",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              boxId: boxId, organizationId: this.organizationId
            }),
          });
        },
        " "
      );
    },

    remove(id) {
      let self = this;
      this.$awn.asyncBlock(
        organizationService.deleteBox(id, this.organizationId),
        (response) => {
          if (response) {
            self.$parent.getAllBoxes(
              self.organizationId,
              self.paginationBox.page - 1,
              self.paginationBox.itemsPerPage,
              { name: this.searchBox }
            );
            //Close modal
            self.$bvModal.hide("modal-new");

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.box.modalCreate.notification.remove.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.box.modalCreate.notification.remove.desc"
              ),
              type: "success",
            });

            //:TODO tiene que actualizar el datatable
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "self.$parent.getAllBoxes",
            module: "component-organization-box",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: self.organizationId,
              page: self.paginationBox.page - 1,
              itemsPerPage: self.paginationBox.itemsPerPage,
              data: { name: this.searchBox }
            }),
          });
        },
        " "
      );
    },

    updateBox() {
      var data = {
        id: this.id,
        name: this.name,
      };
      let self = this;
      this.$awn.asyncBlock(
        organizationService.updateBox(self.id, this.organizationId, data),
        (response) => {
          if (response) {
            self.$parent.getAllBoxes(
              self.organizationId,
              self.paginationBox.page - 1,
              self.paginationBox.itemsPerPage,
              { name: this.searchBox }
            );
            //Close modal
            self.$bvModal.hide("modal-new");

            self.$notify({
              group: "notificacions",
              title: self.$i18n.t(
                "public.components.organization.box.modalCreate.notification.update.title"
              ),
              text: self.$i18n.t(
                "public.components.organization.box.modalCreate.notification.update.desc"
              ),
              type: "success",
            });

            //:TODO tiene que actualizar el datatable
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.updateBox",
            module: "component-organization-box",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: self.id, organizationId: this.organizationId, data: data
            }),
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      paginationBox: { page: 1, itemsPerPage: 10 },
      taxInput: false,
      action: "",
      disabled: false,
      isValidateStep1: false,
      validatorStep1: validator,
      //Campos
      name: "",
      //Tablas
      searchBox: "",

      headersBoxes: [
        {
          text: this.$i18n.t("public.components.organization.box.headers.name"),
          align: "start",
          value: "name",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      visitType: [],
    };
  },
};
</script>
